// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"05f4e775bd3bd42162f2","303":"2197f264910d76ad51aa","495":"e8342f0a0518fe6211f2"}[chunkId] + ".js";
};